import React from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './DashboardLayout.css';

const DashboardLayout = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="dashboard-container">
      <div className="sidebar">
        <div className="logo">
          <img
            src="/logo512.png"
            alt="AAGC Admin"
            style={{ width: 200, height: 50, objectFit: 'contain' }}
          />
        </div>
        <nav>
          <ul>
            <li onClick={() => navigate('/dashboard')}>
              <i className="fas fa-tachometer-alt"></i>
              <span>Dashboard</span>
            </li>
            <li onClick={() => navigate('/dashboard/slider')}>
              <i className="fas fa-images"></i>
              <span>Slider</span>
            </li>
            <li onClick={() => navigate('/dashboard/news')}>
              <i className="fas fa-newspaper"></i>
              <span>News</span>
            </li>
            <li onClick={() => navigate('/dashboard/about')}>
              <i className="fas fa-info-circle"></i>
              <span>About</span>
            </li>
            <li onClick={() => navigate('/dashboard/what-is-gymkhana')}>
              <i className="fas fa-question-circle"></i>
              <span>What is Gymkhana</span>
            </li>
            <li onClick={() => navigate('/dashboard/events')}>
              <i className="fas fa-calendar-alt"></i>
              <span>Events</span>
            </li>
            <li onClick={() => navigate('/dashboard/drivers')}>
              <i className="fas fa-id-card"></i>
              <span>Driver Registrations</span>
            </li>
            <li onClick={() => navigate('/dashboard/gallery')}>
              <i className="fas fa-images"></i>
              <span>Gallery</span>
            </li>
            <li onClick={() => navigate('/dashboard/history')}>
              <i className="fas fa-history"></i>
              <span>History</span>
            </li>
            <li onClick={() => navigate('/dashboard/regulations')}>
              <i className="fas fa-book"></i>
              <span>Regulations</span>
            </li>
            <li onClick={() => navigate('/dashboard/championship-stats')}>
              <i className="fas fa-trophy"></i>
              <span>Championship Stats</span>
            </li>
            <li onClick={() => navigate('/dashboard/contact')}>
              <i className="fas fa-address-book"></i>
              <span>Contact</span>
            </li>
            <li onClick={() => navigate('/dashboard/messages')}>
              <i className="fas fa-envelope"></i>
              <span>Messages</span>
            </li>
            <li onClick={() => navigate('/dashboard/community')}>
              <i className="fas fa-users"></i>
              <span>Community Members</span>
            </li>
            <li onClick={handleLogout} className="logout">
              <i className="fas fa-sign-out-alt"></i>
              <span>Logout</span>
            </li>
          </ul>
        </nav>
      </div>
      <div className="main-content">
        <header>
          <h1>Admin Dashboard</h1>
          <button onClick={handleLogout} className="logout-btn">
            <i className="fas fa-sign-out-alt"></i>
            LOGOUT
          </button>
        </header>
        <div className="content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
